import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Category10 from "../../components/category/Category10";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

import Breadcrumbepooja from "../../components/breadcrumbepooja";
import { useParams } from "react-router-dom";

function EpoojaDetails(props) {

  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({ status: false });
    } else {
      setToggle({ status: true, key });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({ live: false });
    window.wow.init();
  }, []);

  // SAME NAV APIs
  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
  const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
    fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort");
    setCategories(res.data);
  };

  const fetchCategoriesnew = async () => {
    const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort");
    setCategoriesnew(res.data);
  };

  const fetchCategoriesnew1 = async () => {
    const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort");
    setCategoriesnew1(res.data);
  };

  const fetchCategoriesnew2 = async () => {
    const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort");
    setCategoriesnew2(res.data);
  };

  const [language, setLanguage] = useState("en");
  const { clientId } = useParams();

  const [category, setCategory] = useState({
  Title: "",
  Title2: "",
  Path1: "",
  Descriptions: "",
  Descriptions2: "",
  Sdesc: "",
  Sdesc2: "",
  VideoUrl: "",
});

  useEffect(() => {
    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-epooja-details/${clientId}`)
      .then((res) => setCategory(res.data));
  }, [clientId]);

  const hasHindi = Boolean(
  category.Descriptions2
    ?.replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim()
);

const hasHindiTitle = Boolean(
  category.Title2
    ?.replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim()
);

const hasHindiSdesc = Boolean(
  category.Sdesc2
    ?.replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim()
);

  
  const [author, setAuthor] = useState({
    Aname: "",
    Atitle: "",
    Adesc: "",
    Path1: "",
  });

  
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/epoojas-related`, {
        params: { excludeId: clientId },
      })
      .then((res) => setBlogs(res.data));
  }, [clientId]);

  return (
    <>
      <Helmet>
        <title>
          {category?.Title
            ? `${category.Title} - Adhigyanam | Sauntesthyam LLP`
            : "Loading..."}
        </title>
      </Helmet>

       <div className="menu-mobile-popup">
              <div className="modal-menu__backdrop" onClick={handleMobile}></div>
              <div className="widget-filter">
                <div className="mobile-header">
                  <div id="logo" className="logo">
                    <Link to="/home">
                      <img className="site-logo" src={logo} alt="Image" />
                    </Link>
                  </div>
                  <Link className="title-button-group" onClick={handleMobile}>
                    <i className="icon-close"></i>
                  </Link>
                </div>
      
              <Tabs className="tf-tab">
                  
      
                  <div className="content-tab">
                    <TabPanel className="header-ct-center menu-moblie animation-tab">
                      <div className="nav-wrap">
                        <nav className="main-nav mobile">
                          <ul id="menu-primary-menu" className="menu">
                          <li className="menu-item ">
                              <Link
                                to="/home"
                                className="iteam-menu"
                                
                              >
                                Home
                              </Link>
                            </li>
                            {/* <li className="menu-item ">
                              <Link
                                to="/about"
                                className="iteam-menu"
                                
                              >
                                About Us
                              </Link>
                            </li> */}
      
                         
      
                            <li className="menu-item menu-item-has-children-mobile">
                              <Link
                                to="#"
                                className="iteam-menu"
                                onClick={() => {
                                  handleToggle("services");
                                }}
                              >
                                eConsultation
                              </Link>
                              <Collapse isOpened={toggle.key === "services"}>
                                <ul
                                  className="sub-menu-mobile"
                                  style={{
                                    display: `${
                                      toggle.key === "services" ? "block" : "none"
                                    }`,
                                  }}
                                >
      
       {categoriesnew1.length > 0 ? (
                categoriesnew1.map((categorynew1, index) => (
                  <li key={index} className="menu-item menu-item-mobile">
                    <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
                  </li>
                ))
              ) : (
                <li className="menu-item menu-item-mobile">
                  <span>No categories available</span>
                </li>
              )}
      
                                </ul>
                              </Collapse>
                            </li>
                           
                            <li className="menu-item menu-item-has-children-mobile">
                              <Link
                                to="#"
                                className="iteam-menu"
                                onClick={() => {
                                  handleToggle("courses");
                                }}
                              >
                                eLearning
                              </Link>
                              <Collapse isOpened={toggle.key === "courses"}>
                                <ul
                                  className="sub-menu-mobile"
                                  style={{
                                    display: `${
                                      toggle.key === "courses" ? "block" : "none"
                                    }`,
                                  }}
                                >
                                 {categoriesnew2.length > 0 ? (
                categoriesnew2.map((categoriesnew2, index) => (
                  <li key={index} className="menu-item menu-item-mobile">
                    <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
                  </li>
                ))
              ) : (
                <li className="menu-item menu-item-mobile">
                  <span>No categories available</span>
                </li>
              )}
                                  
                                </ul>
                              </Collapse>
                            </li>
                          <li className="menu-item ">
                              <Link
                                to="/epooja"
                                className="iteam-menu"
                                
                              >
                                ePooja
                              </Link>
                            </li>
                           
                               <li className="menu-item menu-item-has-children-mobile">
                              <Link
                                to="#"
                                className="iteam-menu"
                                onClick={() => {
                                  handleToggle("horoscope");
                                }}
                              >
                               Horoscope
                              </Link>
                              <Collapse isOpened={toggle.key === "horoscope"}>
                                <ul
                                  className="sub-menu-mobile"
                                  style={{
                                    display: `${
                                      toggle.key === "horoscope" ? "block" : "none"
                                    }`,
                                  }}
                                >
      
       {categoriesnew.length > 0 ? (
                categoriesnew.map((categorynew, index) => (
                  <li key={index} className="menu-item menu-item-mobile">
                    <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
                  </li>
                ))
              ) : (
                <li className="menu-item menu-item-mobile">
                  <span>No categories available</span>
                </li>
              )}
      
                                </ul>
                              </Collapse>
                            </li>
                             <li className="menu-item menu-item-has-children-mobile">
                              <Link
                                to="#"
                                className="iteam-menu"
                                onClick={() => {
                                  handleToggle("blog");
                                }}
                              >
                                Blog
                              </Link>
                              <Collapse isOpened={toggle.key === "blog"}>
                                <ul
                                  className="sub-menu-mobile"
                                  style={{
                                    display: `${
                                      toggle.key === "blog" ? "block" : "none"
                                    }`,
                                  }}
                                >
      
       {categories.length > 0 ? (
                categories.map((categories, index) => (
                  <li key={index} className="menu-item menu-item-mobile">
                    <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
                  </li>
                ))
              ) : (
                <li className="menu-item menu-item-mobile">
                  <span>No categories available</span>
                </li>
              )}
      
                                </ul>
                              </Collapse>
                            </li>
                            <li className="menu-item ">
                              <Link
                                to="/support"
                                className="iteam-menu"
                                
                              >
                               FAQ & Support
                              </Link>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </TabPanel>
      
                 
                  </div>
                </Tabs>
                <div className="header-customize-item button" style={{padding: "0px 0px",
          background:"none",
          backgroundColor:"#14a077",
          borderRadius: "4px",
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "21px",
          color: "white",
          borderColor: "transparent",
          textTransform: "capitalize"}}>
                  <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
                </div>
                <div className="header-customize-item button">
                  <Link to="/login">My Account</Link>
                </div>
      
                <div className="mobile-footer">
                  <div className="icon-infor d-flex aln-center">
                    <div className="icon">
                      <span className="icon-call-calling">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                      </span>
                    </div>
                    <div className="content">
                      <p>Need help? 24/7</p>
                      <h6>
                         <Link to={`tel:918960708425`}>+91-8960708425</Link>
                      </h6>
                    </div>
                  </div>
                  <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
                  <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
                  <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
            <ul className="list-social d-flex aln-center">
                                           <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                           <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                           <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                       </ul>
          </div>
                </div>
              </div>
            </div>

      <Header2 clname="act1" handleMobile={handleMobile} />
      <Breadcrumbepooja title="ePooja Guide" />

      {/* MAIN SECTION */}
      <section className="testimonials-category-section" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <div className="tf-container">
          <div className="row" style={{ maxWidth: "1200px", margin: "auto" }}>

            {/* LEFT */}
            <div className="col-lg-8 col-12">




                <div className="row" style={{textAlign:"center", maxWidth:"1200px", margin:"auto"}}>

                  <>
  <style>{`
    .rich-content img {
      display: block;
      margin: 10px auto;
      max-width: 100%;
      height: auto;
      float: none !important;
      width: 100% !important;
    }

    .switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #ccc;
  transition: 0.3s;
  border-radius: 34px;
}

.slider:before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background: #0d6efd;
}

input:checked + .slider:before {
  transform: translateX(24px);
}
  `}</style>

  {(hasHindi || hasHindiTitle || hasHindiSdesc) && (
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    marginBottom: "0px",
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "15px",
  }}
>
  <span>English</span>

  <label className="switch">
    <input
      type="checkbox"
      checked={language === "hi"}
      onChange={(e) => setLanguage(e.target.checked ? "hi" : "en")}
    />
    <span className="slider"></span>
  </label>

  <span>हिन्दी</span>
</div>
)}
                   
                   <h6 style={{marginTop:"20px", marginBottom:"5px"}}>
  {language === "hi" && hasHindiTitle
    ? category.Title2
    : category.Title}
</h6>

<p style={{marginBottom:"10px"}}>
  {language === "hi" && hasHindiSdesc
    ? category.Sdesc2
    : category.Sdesc}
</p>

<img
  src={category.Path1}
  alt={
    language === "hi" && hasHindiTitle
      ? category.Title2
      : category.Title
  }
  style={{
    width: "80%",
    height: "auto",
    borderRadius: "10px",
    margin:"auto"
  }}
/>

                  

            

 <div
  className="rich-content"
  style={{
    marginBottom: "5px",
    marginTop: "10px",
    textAlign: "left",
  }}
  dangerouslySetInnerHTML={{
    __html:
      language === "hi" && hasHindi
        ? category.Descriptions2
        : category.Descriptions,
  }}
></div>
</>

               {category.VideoUrl && (
                <div style={{ marginTop: "20px" }}>
                  <iframe
                    width="100%"
                    height="400"
                    src={category.VideoUrl}
                    title="Video"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              )}

              {/* INFO BOX */}
              <div style={{ border: "solid #f2f2f2 2px", borderRadius: "5px", marginTop: "20px", backgroundColor: "#fafafa" }}>
                <p style={{ padding: "15px" }}>
                  <b>Knowledge Based ePooja Guide</b><br />
                  This content is intended for informational purposes to guide pooja preparation and rituals.
                </p>
              </div>


                    </div>


            

            
         

           
                

         
       

          </div>
           <div className="col-lg-4 col-12">
              <div className="box-content" style={{ marginTop: "25px" }}>
                <h3 style={{ fontSize: "16px", textTransform: "uppercase" }}>
                  <b>Other Guides</b>
                </h3>
                <hr />

                {blogs.map((item, index) => (
                  <div key={index} style={{ padding: "20px", background: "whitesmoke", marginBottom: "15px", borderRadius: "5px" }}>
                    <Link to={`/epooja-details/${item.Id}`}>
                      <img src={item.Path1} alt="" />
                      <h6  style={{fontSize:"17px", lineHeight:"21px", paddingTop:"12px"}}>{item.Title}</h6>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
        </div>
        </div>
      </section>

      <div
               className="floating-buttons"
               style={{
                 position: "fixed",
                 bottom: "20px",
                 left: "20px",
                 zIndex: "1000",
                 display: "flex",
                 flexDirection: "column",
                 gap: "10px",
               }}
             >
               {/* Call Button */}
               <a
                 href={`tel:+918960708425`}
                 style={{
                   display: "flex",
                   alignItems: "center",
                   justifyContent: "center",
                   width: "60px",
                   height: "60px",
                   backgroundColor: "#007BFF",
                   borderRadius: "50%",
                   boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                   color: "white",
                   fontSize: "28px",
                 }}
               >
                 <FaPhoneAlt />
               </a>
             
               {/* WhatsApp Button */}
               <a
                 href={`https://wa.me/918960708425`}
                 target="_blank"
                 rel="noopener noreferrer"
                 style={{
                   display: "flex",
                   alignItems: "center",
                   justifyContent: "center",
                   width: "60px",
                   height: "60px",
                   backgroundColor: "#25D366",
                   borderRadius: "50%",
                   boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                   color: "white",
                   fontSize: "28px",
                 }}
               >
                 <FaWhatsapp />
               </a>
             </div>
      <Footer />
      <Gotop />
    </>
  );
}

export default EpoojaDetails;